module.exports = __webpack_public_path__ + "img/login_banner.a00ab36a.jpg";